import { generateId } from './helpers';

function daysFromNow(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}

export function createSampleData() {
  const members = [
    { id: generateId(), name: 'Mum', colour: '#a855f7' },
    { id: generateId(), name: 'Dad', colour: '#14b8a6' },
    { id: generateId(), name: 'Sophie', colour: '#f97316' },
    { id: generateId(), name: 'Jack', colour: '#ec4899' },
  ];

  const holidays = [
    {
      id: generateId(),
      destination: 'Portugal Beach Trip',
      emoji: '🏖️',
      tripType: 'holiday',
      departureDate: daysFromNow(45),
      returnDate: daysFromNow(52),
      status: 'booked',
      totalBudget: 3200,
      familyMembers: members.map(m => m.id),
      expenses: [
        {
          id: generateId(),
          description: 'Flight booking (Ryanair)',
          amount: 800,
          dueDate: daysFromNow(-30),
          isPaid: true,
          paidDate: daysFromNow(-30),
          assignedTo: 'shared',
        },
        {
          id: generateId(),
          description: 'Villa deposit',
          amount: 400,
          dueDate: daysFromNow(-14),
          isPaid: true,
          paidDate: daysFromNow(-14),
          assignedTo: 'shared',
        },
        {
          id: generateId(),
          description: 'Villa balance',
          amount: 800,
          dueDate: daysFromNow(14),
          isPaid: false,
          paidDate: null,
          assignedTo: 'shared',
        },
        {
          id: generateId(),
          description: 'Water park tickets',
          amount: 120,
          dueDate: daysFromNow(30),
          isPaid: false,
          paidDate: null,
          assignedTo: 'shared',
        },
        {
          id: generateId(),
          description: 'Food budget',
          amount: 500,
          dueDate: daysFromNow(44),
          isPaid: false,
          paidDate: null,
          assignedTo: 'shared',
        },
        {
          id: generateId(),
          description: 'Spending money',
          amount: 400,
          dueDate: daysFromNow(44),
          isPaid: false,
          paidDate: null,
          assignedTo: 'shared',
        },
      ],
      notes: 'Beautiful villa near Albufeira with pool! Kids are so excited 🌊',
      createdAt: new Date().toISOString(),
    },
    {
      id: generateId(),
      destination: 'Christmas Markets Vienna',
      emoji: '🏰',
      tripType: 'short-break',
      departureDate: daysFromNow(120),
      returnDate: daysFromNow(124),
      status: 'booked',
      totalBudget: 1800,
      familyMembers: [members[0].id, members[1].id],
      expenses: [
        {
          id: generateId(),
          description: 'Flight deposit',
          amount: 150,
          dueDate: daysFromNow(-7),
          isPaid: true,
          paidDate: daysFromNow(-7),
          assignedTo: 'shared',
        },
        {
          id: generateId(),
          description: 'Flight balance',
          amount: 300,
          dueDate: daysFromNow(60),
          isPaid: false,
          paidDate: null,
          assignedTo: 'shared',
        },
        {
          id: generateId(),
          description: 'Hotel booking',
          amount: 600,
          dueDate: daysFromNow(60),
          isPaid: false,
          paidDate: null,
          assignedTo: 'shared',
        },
        {
          id: generateId(),
          description: 'Opera tickets',
          amount: 120,
          dueDate: daysFromNow(90),
          isPaid: false,
          paidDate: null,
          assignedTo: 'shared',
        },
        {
          id: generateId(),
          description: 'Spending money',
          amount: 250,
          dueDate: daysFromNow(119),
          isPaid: false,
          paidDate: null,
          assignedTo: 'shared',
        },
      ],
      notes: 'Romantic getaway — just the two of us! 🎄',
      createdAt: new Date().toISOString(),
    },
    {
      id: generateId(),
      destination: 'Disney World 2026',
      emoji: '🎢',
      tripType: 'holiday',
      departureDate: daysFromNow(300),
      returnDate: daysFromNow(314),
      status: 'dream',
      totalBudget: 5000,
      familyMembers: members.map(m => m.id),
      expenses: [
        {
          id: generateId(),
          description: 'Savings pot',
          amount: 800,
          dueDate: daysFromNow(-5),
          isPaid: true,
          paidDate: daysFromNow(-5),
          assignedTo: 'shared',
        },
      ],
      notes: 'The big one! Need to save £5,000 total. Currently putting away £200/month.',
      createdAt: new Date().toISOString(),
    },
  ];

  return { holidays, members, shoppingList: [] };
}
